import { useState } from 'react';
import { Link } from 'react-router-dom';
import { getWritingMode, setWritingMode, type WritingModeType } from '../config/writingMode';

interface WritingModeSwitcherProps {
  planned?: number;
  limit?: number;
  dueCount?: number;
  onModeChange?: (mode: WritingModeType) => void;
}

/**
 * 写作模式切换组件
 * 用于 Cloudflare 版本在静态题库和 AI Writing 之间切换
 * 使用紧凑的 toggle 样式，不破坏卡片高度
 */
export function WritingModeSwitcher({ planned = 0, limit = 0, dueCount = 0, onModeChange }: WritingModeSwitcherProps) {
  const [mode, setMode] = useState<WritingModeType>(getWritingMode);
  
  // 模式切换时持久化并通知父组件
  const handleModeChange = (newMode: WritingModeType) => {
    setMode(newMode);
    setWritingMode(newMode);
    onModeChange?.(newMode);
  };
  const progress = limit > 0 ? Math.min((planned / limit) * 100, 100) : 0;

  return (
    <article className="skill-card">
      <div className="skill-card-header">
        <div className="skill-card-title">
          <span className="skill-dot writing" />
          <span>写作</span>
          {/* 紧凑的 toggle 切换器 */}
          <div
            style={{
              display: 'inline-flex',
              marginLeft: '8px',
              border: '1.5px solid var(--border-color)',
              borderRadius: '3px',
              overflow: 'hidden',
              fontSize: '10px',
              fontWeight: 700,
            }}
          >
            <button
              onClick={() => handleModeChange('static')}
              style={{
                padding: '2px 6px',
                border: 'none',
                cursor: 'pointer',
                background: mode === 'static' ? 'rgba(0,0,0,0.1)' : 'transparent',
                color: 'inherit',
              }}
            >
              个人
            </button>
            <button
              onClick={() => handleModeChange('ai')}
              style={{
                padding: '2px 6px',
                border: 'none',
                borderLeft: '1.5px solid var(--border-color)',
                cursor: 'pointer',
                background: mode === 'ai' ? 'rgba(0,0,0,0.1)' : 'transparent',
                color: 'inherit',
              }}
            >
              AI
            </button>
          </div>
        </div>
        <div className="skill-card-count">{planned}/{limit}</div>
      </div>

      <div className="skill-card-progress">
        <div className="progress">
          <div className="progress-fill" style={{ width: `${progress}%` }} />
        </div>
        <span className="caption">DUE {dueCount}</span>
      </div>

      <Link
        className="btn btn-primary"
        to={mode === 'ai' ? '/ai-writing' : '/session/writing'}
      >
        START →
      </Link>
    </article>
  );
}
